export const captchaStatusCodes = [777, 778, 779, 780];

export const errorStatusCodes = [502, ...captchaStatusCodes];
